import React, { useState, useEffect, useCallback, useRef } from 'react'
import { getThemeListPromise } from 'api/Theme'
import Table from './table'
import Toolbar from './toolbar'
import { useLocation } from 'react-router-dom'
import { useEffectOnce } from 'react-use'
import _ from 'lodash'

const ThemeList = props => {
  const ref = useRef()
  const location = useLocation()
  const [data, setData] = useState([])
  const [params, setParams] = useState({ page: 1 })

  // start
  useEffectOnce(() => {
    const foo = new URLSearchParams(location.search)
    const too = Object.fromEntries(foo.entries())

    setParams({ page: 1, ...too })
  })

  // load data
  useEffect(() => {
    const foo = new URLSearchParams(location.search)
    const too = Object.fromEntries(foo.entries())
    getThemeListPromise(too).then(resp => setData(resp))
  }, [location.search])

  const handleParamsChange = useCallback((payload, delay = 0) => {
    if (ref.current) clearTimeout(ref.current)

    const foo = Object.fromEntries(new URLSearchParams(location.search))
    const too = _.pickBy({ ...foo, page: 1, ...payload }, _.identity)
    setParams(too)

    ref.current = setTimeout(() => props.history.push(`?${new URLSearchParams(too)}`), delay)
  }, [location.search, props.history])

  function handlePageChange (event, page) {
    handleParamsChange({ page: page + 1 })
  }
  // end

  return (
    <div className={'root'}>
      <div className={'content'}>
        <Toolbar params={params} handleSearchChange={handleParamsChange} {...props} />
        <br />
        <Table data={data || []} page={params.page} onPageChange={handlePageChange} {...props} />
      </div>
    </div>
  )
}

export default ThemeList
